<template>
  <div ref="tbf" class="tbf"></div>
</template>


<script setup lang="ts">

const tbf = ref<HTMLElement | null>(null);

let observer: IntersectionObserver | null = null;

onMounted(() => {
  observer = new IntersectionObserver(
    ([entry]) => {
      console.log('entry', entry);
      useTopbarFixed().value = !entry.isIntersecting;
    },
    { threshold: 0.1 }
  );

  if (tbf.value) {
    observer.observe(tbf.value);
  }
});


/* --- Optimized scroll listener (SSR‑safe) ----------------------- */
let lastScrollTop = 0;
let ticking = false;
let handleScroll: (() => void) | null = null;

if (typeof window !== 'undefined') {
  const updateScrollState = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    useTopbarFixedScrollDown().value = scrollTop > lastScrollTop;
    // Reset to 0 for mobile bounce or negative scroll values
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    ticking = false;
  };

  handleScroll = () => {
    // Throttle with requestAnimationFrame to match the browser's repaint rate
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  };

  // Use a passive listener to avoid blocking scrolling
  window.addEventListener('scroll', handleScroll, { passive: true });
}
/* --------------------------------------------------------------- */

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
  if (typeof window !== 'undefined' && handleScroll) {
    window.removeEventListener('scroll', handleScroll);
  }
});

</script>

<style scoped>
 
  .tbf {
    position: absolute;
    top: 52px;
    left: 0;
    width: 1px;
    height: 1px;
    z-index: 100000;
    pointer-events: none;
  }
 
</style>
